import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import customers from "./customers.module";
import employees from "./employees.module";
import layout from "./layout.module";
import projects from "./projects.module";
import providers from "./providers.module";
import settings from "./settings.module";
import statics from "./statics.module";
import tickets from "./tickets.module";
import users from "./users.module";
import budget from "./budget.module";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    counter: 0,
    errors: [],
    isConnected: false,
    globalMessages: [],
    allMessages: [],
    message: {
      content: "",
      type: "",
    },
    error: null,
    history: [],
  },
  mutations: {
    addRouteToHistory(state, route) {
      state.history.push(route);
    },
    CLEAR_ROUTE_HISTORY(state) {
      state.history = [];
    },
    HANDLE_ERROR(state, payload) {
      let msg;
      let r;
      if (payload.data) {
        r = payload.data;
      } else if (payload.response) {
        if (payload.response.data) {
          r = payload.response.data;
        }
      } else {
        r = payload;
      }
      if (r.hasOwnProperty("non_field_errors")) {
        msg = r.non_field_errors[0];
      } else if (r.hasOwnProperty("detail")) {
        msg = r.detail;
      } else {
        msg = r;
      }
      this.commit("SET_MESSAGE", {
        content: msg,
        type: 1,
      });
    },
    SET_MESSAGE(state, payload) {
      state.message = payload;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_MESSAGE(state) {
      state.errors = [];
    },
  },
  getters: {
    getErrors(state) {
      return state.errors;
    },
    getIsConnected(state) {
      return state.isConnected;
    },
    getGlobalMessages(state) {
      return state.globalMessages;
    },
    getGlobalMessageById(state, id) {
      if (id) {
        return state.globalMessages.find((v) => v.pid === id);
      }
    },
  },
  actions: {
    CLEAR_ROUTE_HISTORY({ commit }) {
      commit("CLEAR_ROUTE_HISTORY");
    },
  },

  modules: {
    auth,
    layout,
    statics,
    users,
    employees,
    customers,
    providers,
    projects,
    tickets,
    settings,
    budget,
  },
});
